export default "__VITE_ASSET__C3AG_G7j__"